import AppointmentStatusButton from './AppointmentStatusButton'

export default AppointmentStatusButton
